export default __webpack_public_path__ + "static/media/img-0806-czech-republic-full-face.c05d53c6.png";